"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDayPicker = _interopRequireWildcard(require("react-day-picker"));

require("react-day-picker/lib/style.css");

var _index = require("../../material/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _datepicker_styles = _interopRequireDefault(require("./datepicker_styles"));

var _datepicker_definition = _interopRequireDefault(require("./datepicker_definition"));

var _definecomponent = require("../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // disabled days is an array of days, can include an object that holds a date range
//[
//                     new Date(2017, 3, 12),
//                     new Date(2017, 3, 2),
//                      {
//                     after: new Date(2019, 1, 20),
//                     before: new Date(2019, 1, 25),
//                     }
//                     ]

/* ========== ~~~~~~~~~~ EXPORT : DATE PICKER ~~~~~~~~~~ ========== */


var DatePicker =
/*#__PURE__*/
function (_Component) {
  _inherits(DatePicker, _Component);

  function DatePicker(props) {
    var _this;

    _classCallCheck(this, DatePicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DatePicker).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleDatePickerFormat", function (date) {
      return !date ? null : new Date(date.split('-').join("/"));
    });

    _this.handleDayClick = _this.handleDayClick.bind(_assertThisInitialized(_this));
    _this.handleResetClick = _this.handleResetClick.bind(_assertThisInitialized(_this));
    _this.NavBar = _this.NavBar.bind(_assertThisInitialized(_this));
    _this.state = _this.getInitialState();
    return _this;
  }

  _createClass(DatePicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (JSON.stringify(prevProps.range) !== JSON.stringify(this.props.range)) {
        this.setState({
          from: this.handleDatePickerFormat(this.props.range.from),
          to: this.handleDatePickerFormat(this.props.range.to)
        });
      }
    }
  }, {
    key: "getInitialState",
    value: function getInitialState() {
      return this.props.type === 'day' ? {
        selectedDay: null
      } : {
        from: !!this.props.range.from ? this.handleDatePickerFormat(this.props.range.from) : null,
        to: !!this.props.range.to ? this.handleDatePickerFormat(this.props.range.to) : null
      };
    }
  }, {
    key: "handleDayClick",
    value: function handleDayClick(day) {
      var modifiers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}; //the modifiers object holds data on the click event like disabled,selected, etc..

      if (modifiers.disabled) return null;

      if (this.props.type === 'day') {
        this.props.handleRangeSelect(day);
        this.setState({
          selectedDay: modifiers.selected ? undefined : day
        });
      } else {
        var range = _reactDayPicker.DateUtils.addDayToRange(day, this.state);

        if (this.state.from !== "" && this.state.to !== "") {
          this.setState({
            from: day,
            to: ""
          });
        } else if (range.to !== null || range.from !== null) {
          this.setState(range);
          this.props.handleRangeSelect(range);
        }
      }
    }
  }, {
    key: "handleResetClick",
    value: function handleResetClick() {
      this.setState(this.getInitialState());
    }
  }, {
    key: "NavBar",
    value: function NavBar(_ref) {
      var nextMonth = _ref.nextMonth,
          previousMonth = _ref.previousMonth,
          onPreviousClick = _ref.onPreviousClick,
          onNextClick = _ref.onNextClick,
          className = _ref.className;
      return _react.default.createElement("div", {
        className: className
      }, _react.default.createElement("div", {
        className: "previousMonth",
        onClick: function onClick() {
          return onPreviousClick();
        }
      }, _react.default.createElement(_index.Icon, {
        name: "chevron-circle-left"
      })), _react.default.createElement("div", {
        className: "nextMonth",
        onClick: function onClick() {
          return onNextClick();
        }
      }, _react.default.createElement(_index.Icon, {
        name: "chevron-circle-right"
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          to = _this$state.to,
          from = _this$state.from;
      var modifiers = {
        start: from,
        end: to
      };
      return _react.default.createElement("div", {
        className: "datepicker ".concat(this.props.classes.datepicker)
      }, _react.default.createElement(_reactDayPicker.default, {
        className: "Selectable",
        selectedDays: this.props.type === 'day' ? this.handleDatePickerFormat(this.props.selectedDay) : [from, {
          from: from,
          to: to
        }],
        modifiers: modifiers,
        onDayClick: this.handleDayClick,
        numberOfMonths: this.props.numberOfMonths,
        navbarElement: this.NavBar,
        disabledDays: this.props.disabledDays,
        fixedWeeks: true
      }));
    }
  }]);

  return DatePicker;
}(_react.Component);
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */


(0, _definecomponent.defineComponent)(DatePicker, _datepicker_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = (0, _reactJss.default)(_datepicker_styles.default)(DatePicker);

exports.default = _default;